<mat-card data-at-add-device-modal>
  <mat-card-header>
    <mat-card-title> Add time phase </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div
      *ngIf="data"
      class="flex flex-row xs:flex-col gap-[8px] justify-start items-center xs:items-start"
    >
      <mat-form-field *ngIf="data.modesOptions?.length" mat-select-height-large data-at-mode>
        <mat-label>{{ 'DIAGNOSTICS.EDIT_START_STOP_TIME.LABEL.MODE' | translate }}</mat-label>
        <mat-select
          data-at-mode-select
          [ngModel]="selectedMode"
          (selectionChange)="onModeChange($event.value)"
          gtm="onOpen"
          gtmAction="Open mode dropdown"
          gtmCategory="diagnosticsTimePhaseModal"
          fieldTextContentTooltip
        >
          <mat-option
            data-at-option
            *ngFor="let mode of data.modesOptions"
            attr.option="option-{{ mode }}"
            [value]="mode"
            gtm="onSelect"
            gtmAction="Mode: '{{ mode }}'"
            gtmCategory="diagnosticsTimePhaseModal"
            fieldTextContentTooltip
          >
            {{ mode }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="flex flex-row gap-[8px] justify-start items-center">
        <mat-form-field mat-select-height-large data-at-start>
          <mat-label>{{
            'DIAGNOSTICS.EDIT_START_STOP_TIME.LABEL.START_TIME' | translate
          }}</mat-label>
          <mat-select
            data-at-start-select
            [ngModel]="selectedStartTime"
            (selectionChange)="onStartTimeChange($event.value)"
            gtm="onOpen"
            gtmAction="Open start time dropdown"
            gtmCategory="diagnosticsTimePhaseModal"
            fieldTextContentTooltip
          >
            <mat-option
              data-at-option
              *ngFor="let time of startTimeOptions"
              attr.option="option-{{ time }}"
              [value]="time"
              gtm="onSelect"
              gtmAction="Start time: '{{ time }}'"
              gtmCategory="diagnosticsTimePhaseModal"
              fieldTextContentTooltip
            >
              {{ time }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span>-</span>
        <mat-form-field mat-select-height-large data-at-stop>
          <mat-label>{{
            'DIAGNOSTICS.EDIT_START_STOP_TIME.LABEL.STOP_TIME' | translate
          }}</mat-label>
          <mat-select
            data-at-stop-select
            [ngModel]="selectedStopTime"
            (selectionChange)="onStopTimeChange($event.value)"
            gtm="onOpen"
            gtmAction="Open stop time dropdown"
            gtmCategory="diagnosticsTimePhaseModal"
            fieldTextContentTooltip
          >
            <mat-option
              data-at-option
              *ngFor="let time of stopTimeOptions"
              attr.option="option-{{ time }}"
              [value]="time"
              gtm="onSelect"
              gtmAction="Stop time: '{{ time }}'"
              gtmCategory="diagnosticsTimePhaseModal"
              fieldTextContentTooltip
            >
              {{ time }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions
    class="flex flex-row xs:flex-col gap-[10px] justify-end items-center xs:justify-start"
  >
    <button
      data-at-add-time-phase-modal-cancel
      gtm="onCancelDialog"
      gtmCategory="diagnosticsPage"
      class="fill-btn xs:order-2"
      mat-button
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      data-at-add-time-phase-modal-add
      gtm="onAddTimePhase"
      class="fill-btn xs:order-1"
      mat-raised-button
      color="primary"
      (click)="onAdd()"
      [disabled]="isAddButtonDisabled()"
    >
      {{ 'GENERAL.BUTTON.ADD' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
